<template>
    <v-container fluid fill-height pa-6 class="main-container">
        <v-layout justify-center align-center class="auth-layout">
            <v-flex text-center>
                <div v-html="require('!html-loader!@/assets/images/logo_image.svg')" class="d-inline-flex mb-60" />
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    class="auth-form"
                    @submit.prevent
                >
                    <div class="auth-form__input mb-1">
                        <label for="email-reset" class="main-text"> E-mail </label>
                        <v-text-field
                            v-model="email"
                            id="email-reset"
                            placeholder="Введите e-mail"
                            class="dark-input"
                            :rules="rules"
                            :error="error"
                            :error-messages="errorMessage"
                            @input="deleteError"
                        ></v-text-field>
                    </div>
                    <div class="main-text mb-60 text-left">
                        На этот e-mail будет отправлено письмо с инструкцией по восстановлению пароля
                    </div>
                    <v-btn
                        :disabled="!valid"
                        class="yellow-btn"
                        type="submit"
                        @click="validate"
                    >
                        Отправить
                    </v-btn>
                    <div class="w-100 d-inline-flex justify-center mt-5">
                        <a href="#" class="auth-link" @click.prevent="openLogin">
                            Я вспомнил пароль
                        </a>
                    </div>
                </v-form>
            </v-flex>
        </v-layout>
        <ModalMessage
            v-model="modalOpen"
            title="E-mail не найден"
            text="Проверьте правильность ввода и повторите попытку"
            text-btn="Хорошо"
            text-center
        />
    </v-container>
</template>

<script>
import ModalMessage from "@/components/modals/ModalMessage";
export default {
    name: 'ResetPassword',
    components: {ModalMessage},
    data() {
        return {
            email: null,
            valid: true,
            rules: [value => !!value || 'Обязательное поле'],
            error: null,
            errorMessage: null,
            modalOpen: false,
        };
    },
    methods: {
        resetPassword() {
            this.$http.post('/users/home/reset-password/', {
                email: this.email,
            })
                .then(() => {
                    this.$router.push({ name: "confirmemail" });
                })
                .catch((error) => {
                    console.error(error);
                    this.modalOpen = true;
                });
        },
        validate() {
            // this.valid = this.$refs.form.validate();
            // if (this.valid) {
                this.resetPassword();
            // } else {
            //     this.errorMessage = "Обязательное поле";
            // }
        },
        deleteError() {
            this.errorMessage = null;
            this.error = false;
        },
        openLogin() {
            this.$router.push({ name: "login" });
        }
    }
}
</script>

<style scoped>
</style>